import React from 'react'
import { ExcelFile, ExcelSheet, ExcelColumn } from '../../utils/excelExport';
import { Oval } from  'react-loader-spinner';
import { connect } from "react-redux";
import ReactTable from "react-table";
import { NavLink as RRNavLink } from 'react-router-dom';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import  ComponentToPrint  from './componentToPrint';
import  ComponentToPrintOne  from './componentToPrintOne';
import Tour from '../../Tour';
import Pagination from '../Pagination/pagination'
import radioButton from '../../assets/radioButton.svg'
import downloadIcon from '../../assets/download.svg'
import NavBar from '../NavBar/navBar'
import {
    fetchBuilding,
    fetchFloors,
    deleteUnit,
    saveUnit,
    fetchRoomList,
    fetchLocationInitialState,
    updateLocationStateFilters,
    downloadLocationData
} from '../../actions';
import {
    Label,
    Input,
    Row,
    Col,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Navbar,
    Nav,
    NavLink,
    Form,
    FormGroup,
    FormFeedback,
    CustomInput,
} from 'reactstrap'
import { toast, ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faPrint, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import isEqual from "react-fast-compare";
import "react-table/react-table.css";
import './location.css'
import moment from 'moment';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg';
import deleteIcon from '../../assets/delete.svg'
import Draggable from 'react-draggable';


// const ExcelFile = ExcelFile;
// const ExcelSheet = ExcelFile.ExcelSheet;
// const ExcelColumn = ExcelFile.ExcelColumn;
let errorDetails = ""
class Location extends React.Component {
    constructor(props) {
        super(props)
        this.props.fetchLocationInitialState()
        this.props.fetchBuilding();
        this.resetData = this.resetData.bind(this)
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.onSelectFloor = this.onSelectFloor.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            ...this.props.initialState,
            fileName: "Location_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
            isPrintModal: false,
            isPrintAllModal: false,
            checked: [],
            loaderLocations: true,
        }
    }

    componentDidMount = () => {
        let persist_root = localStorage.getItem('persist:root')
        var root = JSON.parse(persist_root);
        var location_data = JSON.parse(root.location_data)
        this.props.downloadLocationData().then(
            response => {
                this.setState({ loaderLocations: false })
            }
        )
        if(location_data.downloadLocationData===undefined || location_data.downloadLocationData.length===0 ){
            this.setState({ loaderLocations: true })
        }
        else{
            this.setState({ loaderLocations: false })
        }
    }

    onSelectBuilding = (event) => {
        this.props.updateLocationStateFilters(event)
    }

    onSelectFloor = (event) => {
        this.props.updateLocationStateFilters(event)
    }

    onSelectRoom = (event) => {
        this.props.updateLocationStateFilters(event)
    }

    handleChange = (event) => {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        })
    }

    resetData = () => {
        this.props.fetchLocationInitialState()
        this.setState(prevState => ({
            isAddModalOpen: false,
            isDeleteModalOpen: false,
            buildingId: ""
        }))
        this.props.downloadLocationData()
        this.props.fetchFloors(this.state.buildingId)
    }

    toggleAddModal = () => {
        this.setState(prevState => ({
            isAddModalOpen: !prevState.isAddModalOpen,
            unitDescription: "",
            deleteUnitId: "",
            descriptionError: "",
            deleteUnitName: ""
        }))
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteUnitId: "",
            deleteUnitName: ""
        }));
    }

    handleButtonClick = (e, row) => {
        this.setState(prevState => ({
            deleteUnitId: row.original.unit.id,
            deleteUnitName: row.original.location_id + '_' + row.original.unit.unit_id,
            isDeleteModalOpen: !prevState.isDeleteModalOpen
        }));
    }
    handlePrintClick = (e, location_id,unit) => {
        if(unit && unit.unit_id)
        this.setState(prevState => ({
            isPrintModal: !prevState.isPrintModal,
            barcodeValue: location_id +'_'+unit.unit_id
        }));
        else
        {
            this.setState(prevState => ({
                isPrintModal: !prevState.isPrintModal,
                barcodeValue: location_id 
            })); 
        }
    }

    printLocation = (flag = false) => {
        if (flag===true)
        {
        document.getElementById("wrapper_ref_all").style.display = 'inline'
        this.componentRef=document.getElementById("wrapper_ref_all");
        }
        this.setState({ isPrintAllModal: false, isPrintModal: false,checked: [] })
    }
    onUnitDescriptionChange = (e) => {
        this.setState({
            unitDescription: e.target.value,
            descriptionError: ""
        });
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.initialState, this.props.initialState)) {
            this.setState(this.props.initialState, () => {
                if (!isEqual(prevProps.initialState.building, this.props.initialState.building) || !isEqual(prevProps.initialState.addBuilding, this.props.initialState.addBuilding)) {
                    this.props.fetchFloors(this.state.buildingId)
                }
                if (!isEqual(prevProps.initialState.floor, this.props.initialState.floor) || !isEqual(prevProps.initialState.addFloor, this.props.initialState.addFloor)) {
                    this.props.fetchRoomList({
                        building: this.state.buildingId,
                        floor: this.state.floorId
                    })
                }
            })
        }
    }

    saveUnit = () => {
        if (this.validateUnitData(this.state)) {
            this.props.saveUnit({
                location: this.state.addRoom,
                description: this.state.unitDescription
            }).then(response => {
                if (response.status === 201) {
                    let message = <span><i>{response.data.description}</i> added successfully for this Room!</span>
                    appInsights.trackEvent({name: 'Unit Added', properties:{name: response.data.description, id: response.data.location}});
                    appInsights.trackTrace({message: 'Unit Added', properties:{name: response.data.description, id: response.data.location}, severityLevel: SeverityLevel.Information})
                    toast.success(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    this.setState({unitDescription: ""})
                }
                else {
                    let message = "Unit couldn't be added!"
                    appInsights.trackTrace({message: message, properties:{name: this.state.unitDescription, id: this.state.addRoom}, severityLevel: SeverityLevel.Error})
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
                this.props.downloadLocationData()
            })
                .catch((error) => {
                    let errors = error.data
                    let errordetails = ""
                    Object.keys(errors).forEach(key => {
                        if (key === 'non_field_errors') {
                            errordetails = errordetails + "Unit Description should be unique for this Room."
                        }
                        else {
                            errordetails = errordetails + errors[key].toString()
                        }
                    })
                    appInsights.trackTrace({message: errordetails, properties:{name: this.state.unitDescription, id: this.state.addRoom, error: errors}, severityLevel: SeverityLevel.Error})
                    toast.error(errordetails, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
                );;
        }
        else {
            this.ErrorDetails()
        }
    }

    ErrorDetails = () => {
        appInsights.trackTrace({message: errorDetails, severityLevel: SeverityLevel.Verbose})
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    validateUnitData = (data) => {
        if (data.buildingId && data.floorId && data.roomId && data.unitDescription.trim().length > 0) {
            return true
        }
        else if (!data.buildingId) {
            errorDetails = "Select the Building from the drop down"
            return false
        }
        else if (!data.floorId) {
            errorDetails = "Select the Floor from the drop down"
            return false
        }
        else if (!data.roomId) {
            errorDetails = "Select the Room from the drop down"
            return false
        }
        else if (data.unitDescription.trim().length === 0) {
            errorDetails = "Unit Description value is empty"
            return false
        }
    }

    deleteUnit = () => {
        this.props.deleteUnit({
            id: this.state.deleteUnitId,
        }).then(response => {
            if (response.status === 204) {
                let message = "Unit Deleted Successfully!"
                appInsights.trackEvent({name: 'Unit Deleted', properties: {id: this.state.deleteUnitId}});
                appInsights.trackTrace({message: 'Unit with ID '+ this.state.deleteUnitId+' is deleted', severityLevel: SeverityLevel.Information});
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.toggleDeleteModal();
            }
            else {
                let message = "Unit couldn't be deleted!"
                appInsights.trackTrace({message: message, properties: {id: this.state.deleteUnitId}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            this.resetData()
            this.props.downloadLocationData()
        }).catch((error) => {
            let errors = error.response.data
            let errordetails = ""
            Object.keys(errors).forEach(key => {
                errordetails = errordetails + errors[key].toString()
            })
            appInsights.trackTrace({message: errordetails, properties: {id: this.state.deleteUnitId, error: errors}, severityLevel: SeverityLevel.Error});
            toast.error(errordetails, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        });;
    }

    columns = [
        {
            Header: state => (
                <CustomInput type="checkbox" 
                className="custom-selectall-checkbox"
                id="locations-all-samples"
                checked={this.props.downloadLocation.length===this.state.checked.length}
                intermediate={this.state.checked.length!==0 && this.props.downloadLocation.length>this.state.checked.length}
                onClick={() => this.selectAll()}/>
                ),
            id: 'checkbox',
            accessor: str => "checkbox",
            Cell: (row) => {
                let checked = this.state.checked.includes(row.index)
                return <CustomInput type="checkbox" className={checked?"custom-table-checkbox select-checked":"custom-table-checkbox"} id={row.original.id} checked={checked} onClick={() => this.handleCheckClick(row.index)}/>
            },
            width: 50,
            filterable:false,
            headerClassName: 'checkbox-sticky-style',
            className: 'checkbox-sticky-style '
        },
        {
            Header: 'Building',
            id: 'buildingsName',
            accessor: str => 'building',
            Cell: (row) => (
                <div>{row.original.floor.building.building_name}</div>
            ),
            headerClassName: "border-cells",
            className: "border-cells",
        },
        {
            Header: 'Floor',
            id: 'floorsName',
            accessor: str => 'floor',
            Cell: (row) => (
                <div>{row.original.floor.floor_name}</div>
            ),
            headerClassName: "border-cells",
            className: "border-cells",
        },
        {
            Header: 'Room',
            id: 'room',
            accessor: str => 'room',
            Cell: (row) => (
                <div>{row.original.room.room_name}</div>
            ),
            headerClassName: "border-cells",
            className: "border-cells",
        },
        {
            Header: 'Location ID',
            id: 'location_id',
            accessor: str => 'location',
            Cell: (row) => {
                if (row.original.unit) {
                    return <div>{row.original.location_id + '_' + row.original.unit.unit_id}</div>
                }
                return <div>{row.original.location_id}</div>
            },
            headerClassName: "border-cells",
            className: "border-cells",
        },
        {
            Header: 'Description',
            accessor: 'description',
            headerClassName: "border-cells",
            className: "border-cells",
            Cell: (row) => {
                if (row.original.unit) {
                    return <div>{row.original.description + ', ' + row.original.unit.description}</div>
                }
                else {
                    return <div>{row.original.description}</div>
                }
            },
        },
        {
            Header: 'Unit',
            id: 'unit',
            accessor: str => 'unit',
            Cell: (row) => {
                if (row.original.unit) {
                    return <div> {row.original.unit.description}</div >
                }
                return <div />
            },
            headerClassName: "border-cells",
            className: "border-cells",
        },
        {
            id: 'delete',
            accessor: str => 'delete',
            Cell: (row) => {
                if (row.original.unit) {
                    return <img className="delete-unit-icon" size="lg" id={"deleteButton" + row.original.location_id + '_' + row.original.unit.unit_id} onClick={(e) => this.handleButtonClick(e, row)} data-tut="reactour__delete" src={deleteIcon}/>
                }
                return null
            },
            headerClassName: "",
            width: 50
        }
    ]

    handleCheckClick = (value) =>{
        this.setState(prevState => ({
            checked: prevState.checked.includes(value)?[...prevState.checked.filter((val) => val !== value)]:[...prevState.checked, value],
        }))
    }

    selectAll = () => {
        this.setState({
        checked: this.state.checked.length < this.props.downloadLocation.length?[...Array(this.props.downloadLocation.length).keys()]:[]})
    }

    applyFilter = () => {
        var data = {
            floor__id: this.state.floorId,
            floor__building_id: this.state.buildingId,
            room: this.state.roomId,
        }
        this.props.downloadLocationData(data)
    }

    getFileName = () => {
        let Filename = "Location_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        this.setState({ fileName: Filename })
    }
    togglePrintModal = () => {
        this.setState(prevState => ({
            isPrintModal: !prevState.isPrintModal
        }));
    }

    togglePrintAllModal = () => {
        this.props.downloadLocationData();
        this.setState(prevState => ({
            isPrintAllModal: !prevState.isPrintAllModal,
        })
        );
    }
    render() {
        return (
            <div className="manage-page manage-location-page page-layout" data-tut="reactour__manage" >
                <NavBar />
                <div className={window.innerWidth>900?"dashboard-overview samples-page": "dashboard-overview-100 samples-page"}> 
                <div className="dashboard-content-25 " ref={(divElement) => { this.divElement = divElement }} >
                <Row className="manage-page-header mt-0" form>
                            <Navbar className="navbar-results " light expand="md">
                                <Nav navbar data-tut="reactour__nav">
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/buildings/addbuildings"><span className="nav-col"><img src={radioButton} className = "nav-icons" alt=''/>Manage Locations</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/locations"><span className="nav-col"><img src={radioButtonhighlighted} className = "nav-icons" alt=''/>View Locations</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/notifications/"><span className="nav-col"><img src={radioButton} className = "nav-icons" alt=''/>Manage Notifications</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row> 
                        <div data-tut="reactour__apply" className = "sample-input-area">
                        <Row form >
                            <Col md={4} xl={2} lg ={2}>
                                <Input className={this.state.building? this.props.sideBarHover?"sample-input-fields no-display" : "sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="building" id="LocationBuildingId" value={this.state.building} onChange={this.onSelectBuilding} size="1">
                                    <option value="" default disabled>Building</option>
                                    {this.props.buildingList.map((building, key) => {
                                        return <option className="dashboard-options" id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                    })}
                                </Input>
                                </Col>
                                <Col  md={4}  xl={2} lg ={2}>
                                <Input className={this.state.floor? this.props.sideBarHover?"sample-input-fields no-display": "sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="floor" id="LocationFloorId" value={this.state.floor} onChange={this.onSelectFloor} size="1">
                                    <option value="" default disabled>Floor</option>
                                    {this.props.floorsList.map((floor) => {
                                        return <option className="dashboard-options" id={floor.id} value={floor.id}>{floor.floor_name}</option>
                                    })}
                                </Input>
                                </Col>
                                <Col  md={4}  xl={2} lg ={2}>
                                <Input className={this.state.room?this.props.sideBarHover?"sample-input-fields no-display": "sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="room" id="LocationRoomId" value={this.state.room} onChange={this.onSelectRoom} size="1">
                                    <option value="" default disabled>Room</option>
                                    {this.props.roomsList.map((rooms) => {
                                        return <option className="dashboard-options" id={rooms.room.id} value={rooms.room.id}>{rooms.room.room_name}</option>
                                    })}
                                </Input>
                                </Col>
                                <Col xl={6} lg={6}>
                                    <div className="manage-buttons">
                                        <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                        <Button id="applyFloorButton" type="submit" outline color="secondary" onClick={this.applyFilter}>Apply</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                </div>
                <div className="grid-data">
                    <Row form className=" sample-list-header ml-0">
                        <Col className="building-heading" sm={4} md={6}>Locations</Col>
                        <Col className="location-header" >
                            <Button id="add-unit-button" onClick={this.state.checked.length === 0 ? this.toggleAddModal : undefined} data-tut="reactour__add" className={this.state.checked.length>0?"add-unit-button disable-delete":"add-unit-button"}><span className = "add-unit-icon">+</span>  Unit</Button>
                            <Button id="add-unit-button" className="add-unit-button" onClick={this.togglePrintAllModal} data-tut="reactour__printAll"><FontAwesomeIcon className="delete-unit-icon print-icon" size="lg" icon={faPrint}></FontAwesomeIcon>Print</Button>
                            {this.props.downloadLocation && this.props.downloadLocation.length > 0 &&
                                <div style={{display: "none"}} element={<Button id="export-data-button" className="export-data-button" onClick={this.getFileName} data-tut="reactour__downloads"><img src={downloadIcon} className="download-icon" alt=''/>Download</Button>} filename={this.state.fileName}>
                                    {this.props.downloadLocation && this.props.downloadLocation.length > 0 ?
                                        <div data={this.props.downloadLocation} name="ManageLocation">
                                            <div label="BuildingName" value={(col) => col.floor.building.building_name} />
                                            <div label="Floor" value={(col) => col.floor.floor_name} />
                                            <div label="Room" value={(col) => col.room.room_name} />
                                            <div label="LocationID" value={(col) => col.unit ? col.location_id + "_" + col.unit.unit_id : col.location_id} />
                                            <div label="Description" value={(col) => col.description} />
                                            <div label="Unit" value={(col) => col.unit ? col.unit.description : " "} />
                                        </div>
                                        : null
                                    }
                                </div>
                            }
                        </Col>
                    </Row>
                    {this.state.loaderLocations? 
                    <>
                        <div className="loader-location-oval"><Oval color="#243682" height={60} width={60} /></div>
                        <div className="no-data-msg"> Please wait while we check for locations...</div> 
                    </>
                    : 
                    <>
                    {this.props.downloadLocation.length > 0 ?
                            <div>
                                <div className="location-table-height sample-table-height" data-tut="reactour__table">
                                    <ReactTable className="Data-Table tables-height"
                                        data={this.props.downloadLocation}
                                        PaginationComponent={Pagination}
                                        columns={this.columns}
                                        showPagination={true}
                                        defaultPageSize={10}
                                        minRows={0}
                                        sortable={false}
                                        getTrProps={(state, rowInfo) => {
                                            if (rowInfo && rowInfo.row) {
                                              return {
                                                onClick: () => { this.handleCheckClick(rowInfo.index) },
                                                className: this.state.checked.includes(rowInfo.index) ? "table-selected-row" : "",
                                              }
                                            }else{
                                              return {}
                                            }
                                          }
                                        }
                                    />
                                </div>
                             </div> 
                            : 
                            <>
                            {this.props.downloadLocation.length === 0?
                                <div className="no-data-msg"> No Locations Available</div>
                                :
                                null
                            }
                            </>
                        }
                        </>
                    }       
                    </div>
                </div>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isAddModalOpen} toggle={this.toggleAddModal}>
                    <ModalHeader toggle={this.toggleAddModal} className="edit-popup hover-move">Add a Unit</ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup>
                                <Label className="location-label-names">Building <span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="select" name="addBuilding" id="addBuilding" value={this.state.addBuilding} onChange={this.onSelectBuilding} size="1">
                                    <option value="" default disabled>Building</option>
                                    {this.props.buildingList.map((building, key) => {
                                        return <option id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                    })}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label className="location-label-names">Floor <span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="select" name="addFloor" id="addFloor" value={this.state.addFloor} onChange={this.onSelectFloor} size="1">
                                    <option value="" default disabled>Floor</option>
                                    {this.props.floorsList.map((floor) => {
                                        return <option id={floor.id} value={floor.floor_id}>{floor.floor_name}</option>
                                    })}
                                </Input>
                            </FormGroup>
                            <FormGroup >
                                <Label className="location-label-names">Room <span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="select" name="addRoom" id="addRoom" value={this.state.addRoom} onChange={this.onSelectRoom} size="1">
                                    <option value="" default disabled>Room</option>
                                    {this.props.roomsList.map((rooms) => {
                                        return <option id={rooms.room.id} value={rooms.location_id}>{rooms.room.room_name}</option>
                                    })}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label className="location-label-names">Unit Description:<span className="required-icon">*</span></Label>
                                <Input autoFocus invalid={this.state.descriptionError !== ''} type="text" className="add-input-values" name="unit_description" id="unit_description" value={this.state.unitDescription} onChange={this.onUnitDescriptionChange} />
                                <FormFeedback>{this.state.descriptionError}</FormFeedback>
                            </FormGroup>
                        </Form>
                        <div className="float-sm-right">
                            <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={this.resetData}>Cancel</Button>
                            <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={this.saveUnit}>Save</Button>
                        </div>
                    </ModalBody>
                </Modal>
                </Draggable>
                <Modal isOpen={this.state.isDeleteModalOpen} toggle={this.toggleDeleteModal}>
                    <ModalHeader toggle={this.toggleDeleteModal} className="edit-popup delete-title">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                        Delete Location
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        Are you sure you want to delete the unit with id <i>{this.state.deleteUnitName}</i> ?
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer delete-footer-align">
                        <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={this.resetData}>No</Button>
                        <Button id="delete" className="button-size custom-button save-upload-delete-button" onClick={this.deleteUnit}>Yes</Button>
                    </ModalFooter>
                </Modal>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isPrintModal} toggle={this.togglePrintModal} size='lg'>
                    <ModalHeader toggle={this.togglePrintModal} className="edit-popup hover-move">Print Location Id</ModalHeader>
                    <ModalBody>
                    <ComponentToPrintOne barcodeValue={this.state.barcodeValue} ref={(el) => {
                                this.componentRef = el
                            }} />
                        <div className="float-right mt-3">
                            <Button className="button-size-print custom-button cancel-button mr-2" outline color="secondary" onClick={this.togglePrintModal}>Cancel</Button>
                            <ReactToPrint
                                content={() => this.componentRef}
                            >
                                <PrintContextConsumer>
                                    {({ handlePrint }) => (
                                        <button className="button-size-print custom-button save-upload-delete-button" id="save" onClick={() => {
                                            this.printLocation();
                                            handlePrint()
                                        }}>Print </button>
                                    )}
                                </PrintContextConsumer>
                            </ReactToPrint>
                        </div>
                    </ModalBody>
                </Modal>
                </Draggable>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isPrintAllModal} toggle={this.togglePrintAllModal} size="lg">
                    <ModalHeader toggle={this.togglePrintAllModal} className="edit-popup hover-move">Print Location Ids
                    </ModalHeader>
                    <ModalBody>
                        {this.state.checked.length > 0 ?
                            <div>
                                <span className="location-count">Total  LocationIds : {" " + this.state.checked.length}</span>
                                <div className="float-right mt-3">
                                    <Button className="button-size-print custom-button cancel-button mr-2" outline color="secondary" onClick={this.togglePrintAllModal}>Cancel</Button>
                                    <ReactToPrint
                                        content={() => this.componentRef}
                                    >
                                        <PrintContextConsumer>
                                            {({ handlePrint }) => (
                                                <button className="button-size-print custom-button save-upload-delete-button" onClick={() => {
                                                    this.printLocation(true);
                                                    handlePrint()
                                                }}>Print </button>
                                            )}
                                        </PrintContextConsumer>
                                    </ReactToPrint>
                                    <ComponentToPrint downloadLocation={this.state.checked.map((data) => this.props.downloadLocation[data])} ref={(el) => {
                                        this.componentRef = el
                                    }} />
                                </div>
                            </div>
                            :
                            <div>
                    <span className="location-count">Total  LocationIds : {" " + this.props.downloadLocation.length}</span>                       
                        <div className="float-right mt-3">
                            <Button className="button-size-print custom-button cancel-button mr-2" outline color="secondary" onClick={this.togglePrintAllModal}>Cancel</Button>
                            <ReactToPrint
                                content={() => this.componentRef}
                            >
                                <PrintContextConsumer>
                                    {({ handlePrint }) => (
                                        <button className="button-size-print custom-button save-upload-delete-button" onClick={() => {
                                            this.printLocation(true);
                                            handlePrint()
                                        }}>Print </button>
                                    )}
                                </PrintContextConsumer>
                            </ReactToPrint>
                            <ComponentToPrint downloadLocation={this.props.downloadLocation} ref={(el) =>{ 
                                this.componentRef = el
                                }} />
                        </div>
                        </div>
    }
                    </ModalBody>
                </Modal>
                </Draggable>
                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        downloadLocation: state.location_data.downloadLocationData,
        locationPagination: state.location_data.allPagination,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        roomsList: state.floor_data.roomsList,
        locationParams: state.location_data.locationParams,
        initialState: state.location_data.initialState,
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        downloadLocationData,
        fetchBuilding,
        fetchFloors,
        deleteUnit,
        saveUnit,
        fetchRoomList,
        fetchLocationInitialState,
        updateLocationStateFilters
    }
)(Location), 'View Locations', 'Location');